const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');
const BaseView = require('components-framework/view/base.view');

module.exports = BaseView.extend({
    slctrs: {
        errorManagement: '.error_management',
    },

    initialize() {
        this.listenTo(this.model, 'change', this.render);
    },

    events: {
        'tap .no_results_new_search': 'onNewSearch',
        'tap .package_not_available_new_search': 'onNewSearch',
        'tap .package_not_available_same_search': 'onSameSearch',
        'tap .session_expire_new_search': 'onNewSearch',
        'tap .session_expire_same_search': 'onSameSearchExpiredSession',
    },

    render() {
        Odigeo.once('routeChange', () => this.toggleOpenClose(false));
        this.model.get('tracking').load(this.model.get('trackErrorLabel'), this.model.get('trackErrorAction'));
        this.$el.html(this.templates[this.model.get('template')](Odigeo._.extend({
            keys: this.keys,
        }, this.model.toJSON())));
    },

    toggleOpenClose(hasToOpen) {
        this.$el.find(this.slctrs.errorManagement).toggleClass('open', hasToOpen);
    },

    trackingDisplayedEvent() {
        trackFrontEventsUtils.trackJQElementDisplayed(this.$el.find(this.slctrs.errorManagement));
    },

    onNewSearch() {
        this.model.get('tracking').click(this.model.get('trackErrorLabel'), this.model.get('trackErrorAction'));
        Odigeo.Utils.goToApplicationHome(true);
    },

    onSameSearch() {
        Odigeo.Session.set('dpForceNewSearch', 'true');
        this.model.get('tracking').clickSameSearch(this.model.get('trackErrorLabel'), this.model.get('trackErrorAction'));
        this.toggleOpenClose(false);
        Odigeo.Router.reload();
    },

    onSameSearchExpiredSession() {
        Odigeo.Session.set('dpForceNewSearch', 'true');
        this.model.get('tracking').clickSameSearch(this.model.get('trackErrorLabel'), this.model.get('trackErrorAction'));
        this.toggleOpenClose(false);
        Odigeo.trigger('sessionExpireDialog:repeatSearchDynpack');
    },
});
